function createRenderTracker () {
  return {
    issuedRevision: 0,
    renderedRevision: 0,
    waiters: []
  }
}

function issueRenderRevision (tracker) {
  tracker.issuedRevision += 1
  return tracker.issuedRevision
}

function waitForRenderRevision (tracker, revision) {
  if (!Number.isFinite(revision) || revision <= tracker.renderedRevision) {
    return Promise.resolve(tracker.renderedRevision)
  }

  return new Promise(resolve => {
    tracker.waiters.push({ revision, resolve })
  })
}

function markRenderRevisionRendered (tracker, revision) {
  if (!Number.isFinite(revision)) {
    return
  }

  if (revision > tracker.renderedRevision) {
    tracker.renderedRevision = revision
  }

  const remainingWaiters = []
  tracker.waiters.forEach(waiter => {
    if (waiter.revision <= tracker.renderedRevision) {
      waiter.resolve(tracker.renderedRevision)
      return
    }
    remainingWaiters.push(waiter)
  })
  tracker.waiters = remainingWaiters
}

module.exports = {
  createRenderTracker,
  issueRenderRevision,
  waitForRenderRevision,
  markRenderRevisionRendered
}
